import { APIVersion } from './apiVersion';

export default APIVersion.v7;
